<nav class="tabs" role="navigation">
  <a class="tab" routerLink="/readme" routerLinkActive="active">Readme</a>
  <a class="tab" routerLink="/claude" routerLinkActive="active">Claude</a>
  <a class="tab" routerLink="/chatgpt" routerLinkActive="active">ChatGPT</a>  
  <a class="tab" routerLink="/copilot-vs-code" routerLinkActive="active">Copilot VS Code</a>
  <a class="tab" routerLink="/copilot-studio" routerLinkActive="active">Copilot Studio/M365</a>
@if (meStore.isAuthenticated()) {  
  <a class="tab" routerLink="/app/todo" routerLinkActive="active">Todo</a>
  <a class="tab" routerLink="/app/semanticSearch" routerLinkActive="active">Semantic Search</a>
  <div class="username right">{{ meStore.me()!.name }}</div>
  <a href="/.auth/logout?post_logout_redirect_uri=/login" class="tab right">LogOut</a>    
} 
 @else {
  <a class="tab" routerLink="/login" routerLinkActive="active">LogIn</a>
}
</nav>
<main class="content" role="main">
  <router-outlet></router-outlet>
</main>
